import { createContext, useState, ReactNode } from "react";

interface LoaderContextType {
  isLoading: boolean;
  setIsloading: (loading: boolean) => void;
}

export const LoaderContext = createContext<LoaderContextType>({
  isLoading: false,
  setIsloading: () => {},
});

export default function LoaderContextProvider({ children }: { children: ReactNode }) {
  const [isLoading, setIsloading] = useState(false);

  const values = {
    isLoading: isLoading,
    setIsloading: setIsloading,
  };

  return <LoaderContext.Provider value={values}>{children}</LoaderContext.Provider>;
}
